"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapturePreview = exports.CapturePreviewType = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var hidden_image_icon_1 = require("../hidden.image.icon/hidden.image.icon");
var capture_preview_style_1 = require("./capture.preview.style");
(0, theme_1.addStyles)(capture_preview_style_1.Style);
var CapturePreviewType;
(function (CapturePreviewType) {
    CapturePreviewType["THUMBNAIL"] = "thumbnail";
    CapturePreviewType["MEDIUM"] = "medium";
    CapturePreviewType["RAW"] = "raw";
})(CapturePreviewType || (exports.CapturePreviewType = CapturePreviewType = {}));
var DEFAULT_THUMBNAIL_SIZE = 180;
exports.CapturePreview = {
    view: function (collection, capture, ctx) {
        var _a, _b;
        if (ctx === void 0) { ctx = { type: CapturePreviewType.THUMBNAIL }; }
        var draw = services_1.Services.DrawState.getIkeDraw(collection, capture.objectId);
        var className = (0, classnames_1.classNames)(capture_preview_style_1.CSS.container, ctx.className, (_a = {},
            _a[capture_preview_style_1.CSS.selectable] = typeof ctx.action === 'function',
            _a[capture_preview_style_1.CSS.selected] = ctx.selected,
            _a[capture_preview_style_1.CSS.hiddenCapture] = draw.state.imageVisibilityHidden,
            _a));
        var title = ctx.title;
        var onclick = ctx.action;
        var src = ctx.type === CapturePreviewType.THUMBNAIL && capture.thumbnail != null ? capture.thumbnail.url : ctx.type === CapturePreviewType.MEDIUM && capture.medium != null ? capture.medium.url : capture.file.url;
        var size = {
            width: DEFAULT_THUMBNAIL_SIZE,
            height: DEFAULT_THUMBNAIL_SIZE
        };
        if (ctx.size) {
            size.width = ctx.size;
            size.height = ctx.size;
        }
        var renderCtx = tslib_1.__assign(tslib_1.__assign({ draw: draw }, ctx.type === CapturePreviewType.THUMBNAIL && { size: size }), { units: services_1.Services.UserSettings.units, isThumbnail: ctx.type === CapturePreviewType.THUMBNAIL, isInteractive: false, isEditable: false, scale: core_shared_1.SVGRenderer.scaleUI(draw.state, ctx.type === CapturePreviewType.THUMBNAIL) });
        var hiddenIcon = draw.state.imageVisibilityHidden && hidden_image_icon_1.HiddenImageIcon.view();
        var dateElement = (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.date }, services_1.Services.DateTime.formatDate(capture.collectedAt.iso));
        if (!ctx.crosshair && !ctx.truesize) {
            var wrapperClass = (0, classnames_1.classNames)(capture_preview_style_1.CSS.wrapper, (_b = {},
                _b[capture_preview_style_1.CSS.hiddenCapture] = draw.state.imageVisibilityHidden,
                _b));
            return (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.container, title: title, onclick: onclick }, (0, mithril_1.m)('div', { className: wrapperClass }, [
                (ctx.withOverlay || draw.state.brightness !== 1) ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx)) : (0, mithril_1.m)('img', { className: capture_preview_style_1.CSS.image, src: src }),
                hiddenIcon,
                dateElement
            ]));
        }
        if (ctx.truesize) {
            return (0, mithril_1.m)('div', { className: className, title: title, onclick: onclick }, [
                (0, mithril_1.m)('img', {
                    className: capture_preview_style_1.CSS.image,
                    src: src
                }),
                (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx)),
                ctx.icon ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.photomeasure }) : null,
                hiddenIcon,
                dateElement
            ]);
        }
        return (0, mithril_1.m)('div', { className: className, title: title, onclick: onclick }, [
            (0, mithril_1.m)('img', {
                className: capture_preview_style_1.CSS.image,
                src: src
            }),
            draw.state.brightness !== 1 ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.overlay }, core_shared_1.SVGRenderer.view(renderCtx)) : null,
            ctx.crosshair ? (0, mithril_1.m)('div', { className: capture_preview_style_1.CSS.crosshair }) : null,
            hiddenIcon,
            dateElement
        ]);
    }
};
//# sourceMappingURL=capture.preview.js.map